export default {
    SET_FAQ(state, faq) {
        state.faq = faq;
    },
    SET_TOS_STATUS(state, status) {
        state.acceptedTos = status;
    },
    SET_IFRAME_URL(state, url) {
        state.iframeUrl = url;
    },
    SET_FIlES(state, files) {
        state.files = files;
    },
    MARK_AS_READ(state, osid) {
        const index = state.files.findIndex(item => item.osid === osid);
        if (index && index !== -1) {
            state.files[index].isNewEntry = false;
        }
    }
}
